import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/useAuthStore';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import ProductList from './pages/Product/ProductList';
import Layout from './components/layout/Layout';
import OrderList from './components/orderList/OrderList';
import DistributorList from './pages/Distributor/DistributorList';
import TermCondition from './pages/TNC/TermCondition';
import AddProductList from './pages/AddProductCatalogue/AddProductList';
import SummaryTable from './pages/Product/SummaryTable';
import PackerDispatcher from './pages/PackerDispatcher/PackerDispatcher';
import BlockedPopup from './components/Model/BlockedPopup';
import UserDownloadList from './pages/UserDownload/UserDownloadList';
import StockUploadList from './pages/StockUpload/StockUploadList';
import RoleBasedPermissions from './components/RoleBasedPermissions';
import BlockRestrictedUser from './components/BlockRestrictedUser';
import Error404 from './pages/Error/Error404';
import { canAccessStockUpload } from './utils/permissions';

function App() {
  const { isAuthenticated, checkIsLoggedin } = useAuthStore();

  useEffect(() => {
    checkIsLoggedin();
  }, [checkIsLoggedin]);

  const ProtectedRoute = ({ element }) => (
    <Layout isAuthenticated={isAuthenticated}>{element}</Layout>
  );

  /** Wrap pages that permission-400 users must not access. */
  const NonRestrictedRoute = ({ element }) => (
    <BlockRestrictedUser>
      <ProtectedRoute element={element} />
    </BlockRestrictedUser>
  );

  return (
    <>
    <BlockedPopup />
    <Routes>
      {/* Authentication flow */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />

      {/* Inventory — allowed for all authenticated users, including permission 400 */}
      <Route
        path="/"
        element={<ProtectedRoute element={<ProductList />} />}
      />

      {/* Stock Upload — allowed with 300, or 400 + specific user id */}
      <Route
        path="/stock-upload"
        element={
          <RoleBasedPermissions accessCheck={canAccessStockUpload}>
            <ProtectedRoute element={<StockUploadList />} />
          </RoleBasedPermissions>
        }
      />

      {/* All other app pages — blocked for restricted 400 + specific user */}
      <Route
        path="/order-list"
        element={<NonRestrictedRoute element={<OrderList />} />}
      />
      <Route
        path="/add-product-list"
        element={<NonRestrictedRoute element={<AddProductList />} />}
      />
      <Route
        path="/distributor-list"
        element={<NonRestrictedRoute element={<DistributorList />} />}
      />
      <Route
        path="/packer-dispatcher"
        element={<NonRestrictedRoute element={<PackerDispatcher />} />}
      />
      <Route
        path="/summary-list"
        element={<NonRestrictedRoute element={<SummaryTable />} />}
      />
      <Route
        path="/download-list"
        element={<NonRestrictedRoute element={<UserDownloadList />} />}
      />
      <Route
        path="/t&c"
        element={<TermCondition />}
      />
      {/* Full-page error — no sidebar / header / layout */}
      <Route path="/404" element={<Error404 />} />
      {/* <Route
        path="/"
        element={<ProtectedRoute element={<Home />} />}
      /> */}

      {/* Catch-all redirect */}
      <Route
        path="*"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />}
      />
    </Routes>
    </>
  );
}

export default App;
